import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Unity Game Development Services</h2>
            <p>
              Our Unity game development services go beyond the ordinary,
              bringing your ideas to life with a touch of innovation and the
              power of cutting-edge technology. Specializing in{" "}
              <Link to="https://www.tekrevol.com/game-development">
                mobile game development
              </Link>{" "}
              with Unity, we thrive on crafting games that seamlessly blend
              creativity and functionality. Here are the premium game app
              development services that TekRevol offers:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Game App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Unity Game Development</h4>
                  <p>
                    Unity is a fantastic game development platform. It gives us
                    tools to make fun 2D and 3D games that people enjoy. Using
                    Unity, we can create games that work well on phones,
                    computers, and game consoles.It's like a toolbox that helps
                    us make cool games quickly and smoothly. Whether you're
                    playing on your phone or computer, we use Unity to make
                    games that are not only fun but also work really well
                  </p>
                </div>
                <div className="robust-content">
                  <h4>AR/VR/XR - App Development</h4>
                  <p>
                    Our Unity engineers are here to enhance your project by
                    creating high-performance apps with VR/AR/XR features,
                    ensuring users have a great experience. We specialize in
                    solutions for entertainment, games, education, and more.
                    With a portfolio full of similar projects, our Unity gaming
                    company can quickly understand your idea and suggest
                    improvements.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>LiveOps Unity Services</h4>
                  <p>
                    Unity is a valuable tool for LiveOps, and we extend LiveOps
                    services to enhance your development journey. Our LiveOps
                    services cover post-release game maintenance, updates
                    featuring new characters, features, and missions, along with
                    insightful analytics on player activity and more. With our
                    support, your game continues to evolve, keeping players
                    engaged and your content fresh.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
